import React, { useState, useEffect, useContext } from "react";
import {
  StyledButton,
  StyledButtonGenericQuestion,
} from "../../containers/SurveyPreviewPanel/SurveyPreviewPanel.styled";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import { theme as themeConfig } from "../../themes/themes";
import StyleQuestionContainer from "../../containers/StyleQuestionContainer/index";
import {
  GeneralStyle,
  UpperWrapper,
  LowerWrapper,
  VSection,
  QuestionWrapper,
  SelectsSection,
  EditSection,
  AddAndRemove,
  AddDependency,
  RowWrapper,
  ReqField,
  ContainerTitle,
  ContainerButtons,
  ContentLabelStyle,
  OtherOptionButtons,
  EditButton,
  DeleteButton,
  CloneButton,
  SaveToBank,
  TooltipCheckSection,
  TooltipDescriptionContainer,
} from "./MultipleChoiceSingleSelect.styled";
import MessageYesNo from "../MessageYesNo/index";
import { ContextQuestions } from "../../Store/StoreQuestions";
import { ReactComponent as DeleteQuestion } from "../../themes/Icons/delete-question.svg";
import { ReactComponent as CancelQuestion } from "../../themes/Icons/cancel-question.svg";
import { ReactComponent as StyleQuestion } from "../../themes/Icons/style-question.svg";
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import DependentQuestions from "../DependentQuestions/DependentQuestions";
import {
  FormControlLabel,
  Checkbox,
  Box,
  Grid,
  IconButton,
  Tooltip,
} from "@material-ui/core";
import { ReactComponent as CloneIcon } from "../../assets/svg/add-square-icon.svg";
import ModalSaveToBank from "../ModalSaveToBank";
import InfoIcon from "@material-ui/icons/Info";

const MultipleChoiceSingleSelect = ({
  alreadySaved,
  editable,
  title,
  setTitle,
  mandatory,
  setMandatory,
  loadingCat,
  errorCat,
  categories,
  category,
  setCategory,
  validationText,
  setValidationMessage,
  saveQuestionBank,
  handleEdit,
  handleCancel,
  answers,
  handleAdd,
  handleAddOther,
  handleDelete,
  missingFields,
  configQuestionStyle,
  setconfigQuestionStyle,
  handleDeleteQuestion,
  showAddOther,
  handleDeleteOther,
  idQuestionSurvey,
  saveDependencies,
  dependency,
  globalProps,
  identity,
  saveFormQuestion,
  tooltipInformationCheck,
  tooltipDescriptionText,
  setShowTooltipDescription,
  handleTextAreaText,
  changeTooltipInformationCheck,
  showTooltipDescription,
}) => {
  const [showDependency, setshowDependency] = useState({
    show: false,
    answer: "",
  });
  const [stateQuestionsReducer] = useContext(ContextQuestions);
  const [showStyleEdit, setshowStyleEdit] = useState(false);
  const [openMessageYesNoModal, setOpenMessageYesNoModal] = useState(false);
  const [responseMessageYesNo, setResponse] = useState(false);
  const [showSaveToBank, setShowSaveToBank] = useState(false);

  useEffect(() => {
    if (responseMessageYesNo) {
      handleDeleteQuestion();
    }
  }, [responseMessageYesNo]);

  const handleSaveToBank = () => {
    setShowSaveToBank(true);
  };

  let loadAnswers = () => {
    let answerwithoutOther = answers.filter((i) => i.props.other === false);
    return answerwithoutOther.map((item, index) => {
      if (answerwithoutOther.length === index + 1) {
        return (
          <RowWrapper key={index}>
            <ContentLabelStyle
              key={index}
              styleLabel={
                configQuestionStyle.customStyle
                  ? configQuestionStyle.answer
                  : stateQuestionsReducer.globalStyle.answers
              }
            >
              {item}
            </ContentLabelStyle>
            {!globalProps.GisDependent && identity !== "form" && (
              <AddDependency
                alreadySaved={alreadySaved}
                onClick={() =>
                  setshowDependency({
                    show: true,
                    answer: item.props.textAnswers[index],
                  })
                }
              >
                <AccountTreeIcon />
              </AddDependency>
            )}
            <AddAndRemove
              alreadySaved={alreadySaved}
              onClick={() => handleAdd()}
            >
              <AddIcon />
            </AddAndRemove>
            {item.key !== "1" ? (
              <AddAndRemove
                alreadySaved={alreadySaved}
                onClick={() => handleDelete()}
              >
                <RemoveIcon />
              </AddAndRemove>
            ) : null}
          </RowWrapper>
        );
      } else {
        return (
          <RowWrapper key={index}>
            <ContentLabelStyle
              key={index}
              styleLabel={
                configQuestionStyle.customStyle
                  ? configQuestionStyle.answer
                  : stateQuestionsReducer.globalStyle.answers
              }
            >
              {item}
            </ContentLabelStyle>
            {!globalProps.GisDependent && identity !== "form" && (
              <AddDependency
                alreadySaved={alreadySaved}
                onClick={() =>
                  setshowDependency({
                    show: true,
                    answer: item.props.textAnswers[index],
                  })
                }
              >
                <AccountTreeIcon />
              </AddDependency>
            )}
          </RowWrapper>
        );
      }
    });
  };

  let loadAnswersOther = () => {
    return answers.map((item, index) => {
      if (item.props.other) {
        return (
          <RowWrapper key={index}>
            <ContentLabelStyle
              key={index}
              styleLabel={
                configQuestionStyle.customStyle
                  ? configQuestionStyle.answer
                  : stateQuestionsReducer.globalStyle.answers
              }
            >
              {item}
            </ContentLabelStyle>
            <AddAndRemove
              alreadySaved={alreadySaved}
              onClick={() => handleDeleteOther()}
            >
              <RemoveIcon />
            </AddAndRemove>
          </RowWrapper>
        );
      }
    });
  };

  let loadCategories = () => {
    if (loadingCat) return <option key="0">Loading...</option>;
    if (errorCat) return <option key="0">Error :(</option>;
    if (!loadingCat && !errorCat)
      return categories.map(
        ({ recordState, description, idCategoryQuestion }) => {
          if (recordState.toUpperCase() == "ACTIVE") {
            return (
              <option key={idCategoryQuestion} value={idCategoryQuestion}>
                {description}
              </option>
            );
          }
          return null;
        }
      );
  };
  const [colorBackground] = useState("#f9f9f9");
  return (
    <>
      <GeneralStyle
        isDependent={globalProps.GisDependent}
        editable={editable}
        colorBackground={
          configQuestionStyle.customStyle
            ? configQuestionStyle.background
            : colorBackground
        }
        questionBank={globalProps?.questionBank}
      >
        {editable ? (
          <EditSection>
            <VSection>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={mandatory}
                    onChange={(e) => setMandatory(e.target.checked)}
                    name="mandatory-check"
                  />
                }
                label="Mandatory Question"
              />
              {mandatory ? (
                <input
                  onChange={(e) => setValidationMessage(e.target.value)}
                  type="text"
                  placeholder="Enter mandatory message here"
                  id="mText"
                  defaultValue={validationText}
                ></input>
              ) : null}
            </VSection>
            <hr />
            <UpperWrapper>
              <QuestionWrapper>
                <label>Question:</label>
                <textarea
                  onChange={(e) => setTitle(e.target.value)}
                  type="text"
                  placeholder="Enter your question here"
                  defaultValue={title}
                ></textarea>
              </QuestionWrapper>
              {identity !== "form" && (
                <>
                  <Grid container>
                    <Grid item xs={12} sm={6}>
                      <SelectsSection>
                        <div>
                          <label>Category</label>
                          <select
                            onChange={(e) => setCategory(e.target.value)}
                            value={category.toString()}
                          >
                            <option value={0}>- Category -</option>
                            {loadCategories()}
                          </select>
                        </div>
                      </SelectsSection>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        paddingLeft: "35px",
                        paddingTop: "20px",
                      }}
                    >
                      <TooltipCheckSection>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={tooltipInformationCheck}
                              onChange={(e) => {
                                changeTooltipInformationCheck(e.target.checked);
                              }}
                              name="tooltip-info-check"
                            />
                          }
                          label="Add information tooltip to question"
                        />
                      </TooltipCheckSection>
                    </Grid>
                  </Grid>
                  {tooltipInformationCheck && (
                    <Grid
                      container
                      style={{ display: "flex", alignContent: "flex-end" }}
                    >
                      <Grid item xs={12} sm={3}>
                        <></>
                      </Grid>
                      <Grid item xs={12} sm={9}>
                        <TooltipDescriptionContainer>
                          <textarea
                            style={{ height: "80px", resize: "none" }}
                            onChange={(e) => handleTextAreaText(e.target.value)}
                            type="text"
                            placeholder="Type text here..."
                            id="tooltipDescription"
                            defaultValue={tooltipDescriptionText}
                          ></textarea>
                        </TooltipDescriptionContainer>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
            </UpperWrapper>
          </EditSection>
        ) : null}
        <LowerWrapper editable={editable}>
          <ContainerTitle
            style={
              configQuestionStyle.customStyle
                ? configQuestionStyle.question
                : stateQuestionsReducer.globalStyle.questions
            }
          >
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
            >
              {title}
              {tooltipInformationCheck && tooltipDescriptionText !== "" && (
                <Tooltip
                  placement="left"
                  open={showTooltipDescription}
                  title={
                    <>
                      <Box
                        style={{
                          margin: "0",
                          listStyleType: "circle",
                          lineHeight: "1.3",
                          fontSize: "13px",
                        }}
                      >
                        <span>{tooltipDescriptionText}</span>
                      </Box>
                    </>
                  }
                  arrow
                >
                  <IconButton
                    onClick={() => {
                      setShowTooltipDescription(!showTooltipDescription);
                    }}
                  >
                    <InfoIcon
                      fontSize="small"
                      style={{
                        cursor: "pointer",
                        color: themeConfig.text.primary,
                        width: "18px",
                        height: "18px",
                      }}
                    />
                  </IconButton>
                </Tooltip>
              )}
            </Box>
          </ContainerTitle>
          {loadAnswers()}
          {loadAnswersOther()}
          {showAddOther ? (
            <OtherOptionButtons onClick={() => handleAddOther()}>
              Add Other
            </OtherOptionButtons>
          ) : null}
        </LowerWrapper>
        {missingFields ? (
          <ReqField>All answers must have a text</ReqField>
        ) : null}
        {!editable && idQuestionSurvey && !globalProps.questionBank && (
          <div className="overlay-option">
            <div className="bottom-buttons">
              <CloneButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => {
                  if (identity !== "form") {
                    saveQuestionBank(true);
                  } else {
                    saveFormQuestion(true);
                  }
                }}
              >
                <CloneIcon />
                Clone
              </CloneButton>
              {identity !== "form" && (
                <SaveToBank
                  hidden={globalProps.disableButton}
                  className="w-25 mt-2 mb-3"
                  onClick={() => handleSaveToBank()}
                >
                  Save to bank
                </SaveToBank>
              )}
              <DeleteButton
                hidden={globalProps.disableButton}
                className="mx-3 w-25 mt-2 mb-3"
                onClick={() => setOpenMessageYesNoModal(true)}
              >
                Delete
              </DeleteButton>
              <EditButton
                hidden={globalProps.disableButton}
                className="w-25 mt-2 mb-3"
                onClick={() => handleEdit()}
              >
                Edit
              </EditButton>
            </div>
          </div>
        )}
        {editable && (
          <ContainerButtons>
            <div className="left-container">
              <StyledButtonGenericQuestion
                onClick={() => {
                  setshowStyleEdit(true);
                }}
              >
                <StyleQuestion />
                Style
              </StyledButtonGenericQuestion>
              {editable && idQuestionSurvey ? (
                <StyledButtonGenericQuestion onClick={() => handleCancel()}>
                  <CancelQuestion />
                  Cancel
                </StyledButtonGenericQuestion>
              ) : null}
              <StyledButtonGenericQuestion
                lastElement={true}
                onClick={() => setOpenMessageYesNoModal(true)}
              >
                <DeleteQuestion />
                Delete
              </StyledButtonGenericQuestion>
            </div>
            <div className="right-container">
              <StyledButton
                onClick={() => {
                  if (identity !== "form") {
                    saveQuestionBank(false);
                  } else {
                    saveFormQuestion(false);
                  }
                }}
              >
                Save
              </StyledButton>
            </div>
          </ContainerButtons>
        )}
        {showStyleEdit && (
          <StyleQuestionContainer
            setshowStyleEdit={setshowStyleEdit}
            stateObject={configQuestionStyle}
            setstateObject={setconfigQuestionStyle}
          ></StyleQuestionContainer>
        )}
        {openMessageYesNoModal && (
          <MessageYesNo
            setOpenMessageYesNoModal={setOpenMessageYesNoModal}
            message="Are you sure you want to delete this question?"
            setResponse={setResponse}
          ></MessageYesNo>
        )}
      </GeneralStyle>
      {showDependency.show && (
        <DependentQuestions
          dependency={dependency}
          saveDependencies={saveDependencies}
          idQuestionSurvey={idQuestionSurvey}
          setshowDependency={setshowDependency}
          showDependency={showDependency}
        ></DependentQuestions>
      )}
      {showSaveToBank && (
        <ModalSaveToBank
          idQuestion={globalProps?.GidQuestionSurvey}
          category={category}
          categories={categories}
          setModalVisibility={setShowSaveToBank}
        />
      )}
    </>
  );
};

export default MultipleChoiceSingleSelect;
